import React, { useMemo } from "react";

import { styled } from "simplydo/react/styled";
import { CardContent } from "simplydo/react/ui/card";

import GroupInvite from "./Group";
import IdeaInvite from "./Idea";
import IdeaAssessorInvite from "./IdeaAssessor";
import IdeaBusinessProfileInvite from "./IdeaBusinessProfile";
import ProjectInviteCard from "./ProjectInvited";
import RequestJoinGroup from "./RequestJoinGroup";
import RequestJoinIdea from "./RequestJoinIdea";
import type { InviteCardProps } from "./types";

const NoteText = styled.span`
  font-size: 14px;
  color: #718096;
  white-space: pre-wrap;
`;

// Overwrite internal handling of the invitation button to allow wrapping if needed
const Card = styled.div`
  ${CardContent} {
    flex-grow: 0;
  }
`;

const InviteCard = ({
  invitation,
  acceptInvite,
  rejectInvite,
  removeInvite,
  cardView,
}: InviteCardProps) => {
  const CardType = useMemo(() => {
    switch (invitation.forType) {
      case "group":
        return GroupInvite;
      case "idea":
        return IdeaInvite;
      case "ideaBusinessProfile":
        return IdeaBusinessProfileInvite;
      case "requestJoinIdea":
        return RequestJoinIdea;
      case "ideaAssessor":
        return IdeaAssessorInvite;
      case "requestJoinGroup":
        return RequestJoinGroup;
      case "projectInvited":
        return ProjectInviteCard;
      default:
        return null;
    }
  }, [invitation]);

  return (
    <React.Fragment>
      {CardType ? (
        <Card>
          <CardType
            cardView={cardView}
            invitation={invitation}
            acceptInvite={acceptInvite}
            rejectInvite={rejectInvite}
            removeInvite={removeInvite}
          />
          {!invitation.acceptedBy && invitation.note ? (
            <NoteText>
              &quot;
              {invitation.note}
              &quot;
            </NoteText>
          ) : null}
        </Card>
      ) : null}
    </React.Fragment>
  );
};

export default InviteCard;
